<app-nav></app-nav>
<div style="background-color: #e8f4f8">
    <router-outlet></router-outlet>
</div>